module.exports = __webpack_public_path__ + "static/teleco_9-912d7524abb2104fe8bbad787b29deea.jpg";